import { render, staticRenderFns } from "./OptionItem.vue?vue&type=template&id=8b50fbd4&scoped=true&"
import script from "./OptionItem.vue?vue&type=script&lang=ts&"
export * from "./OptionItem.vue?vue&type=script&lang=ts&"
import style0 from "./OptionItem.vue?vue&type=style&index=0&id=8b50fbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b50fbd4",
  null
  
)

export default component.exports